import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_TRAINING_STUDENT_TYPE';

export async function createTrainingStudentType(
    userToken: string,
    payload: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/training-student-types/`,
            data: payload,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de création d\'un type de stagiaire',
            error: error
        });
    }
}
